
export default class EventTrackingModel {
    private customData = {
    };

    action: string;
    readonly timestamp: number;
    appInstanceToken: string;
    uid: string;
    session: string;
    videoId: string;

    constructor() {
        this.timestamp = (new Date()).getTime();
    }

    addCustomData(customData: object) {
        this.customData = {
            ...this.customData, ...customData
        };
    }

    toJson(): string {
        return JSON.stringify({
            action: this.action,
            uid: this.uid,
            instance: this.appInstanceToken,
            session: this.session,
            timestamp: this.timestamp,
            videoId: this.videoId,
            data: Object.keys(this.customData).length
                ? this.customData
                : undefined
        });
    }
}
